<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-indigo">
    <mat-icon>send</mat-icon>
  </div>
  <h2>{{ 'sendEmail' | translate }}</h2>
</div>
<div mat-dialog-content>
  @if (order) {
    @if (mode === 0) {
      <p class="m-0">{{ 'ADMIN.CONFIRM_EMAIL' | translate }}</p>
    }
    @if (mode === 1) {
      <p class="m-0">{{ 'ADMIN.CONFIRM_BAT_EMAIL' | translate }}</p>
    }
    @if (order) {
      <span class="text-sm"> {{'ORDERS.TRANSACTION_ID'|translate}} : {{ order.transactionId}}</span>
    }
    <br/>
    <span class="text-sm"> {{'contactList'|translate}} : {{order.customerEmails.join(', ')}}</span>
  } @else {
    <p class="m-0">{{ 'quotation.confirmEmail' | translate }}</p>
    @if (quotation) {
      <span class="text-sm"> {{'quotation.id'|translate}} : {{quotation.erpId}}</span>
    }
    <br/>
    <span class="text-sm">{{'contactList'|translate}} : {{quotation.contacts.join(', ')}}</span>
  }
</div>
@if (progress) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" [disabled]="progress" (click)="send()">
    <mat-icon>send</mat-icon>
    {{ 'TEMPLATES.VALID' | translate }}
  </button>
</div>
